/* tslint:disable */
/* eslint-disable */
export enum UserProfileConflictType {
  VerificationNotAllowed = 'verification_not_allowed',
  VerificationAlreadyActive = 'verification_already_active',
  UnexpectedVerificationState = 'unexpected_verification_state',
  NoActiveVerification = 'no_active_verification',
  InvalidSecurityToken = 'invalid_security_token'
}
